import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23ad84df"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tip" }
const _hoisted_2 = { class: "tip" }
const _hoisted_3 = { class: "tip" }
const _hoisted_4 = { class: "tip" }
const _hoisted_5 = { class: "tip" }
const _hoisted_6 = { class: "tip" }
const _hoisted_7 = { class: "tip" }
const _hoisted_8 = { class: "dialog-footer" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("关闭")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": true,
    title: _ctx.isEdit ? '编辑' : '新建',
    "before-close": _ctx.dialogHandle.close,
    width: 900,
    "close-on-click-modal": false
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_8, [
        _createVNode(_component_el_button, {
          loading: _ctx.dialogHandle.loading,
          type: "primary",
          onClick: _ctx.dialogHandle.submit
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }, 8, ["loading", "onClick"]),
        _createVNode(_component_el_button, {
          loading: _ctx.dialogHandle.loading,
          type: "info",
          onClick: _ctx.dialogHandle.close
        }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        }, 8, ["loading", "onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref: "formRef",
        model: _ctx.dialogHandle.formData,
        rules: _ctx.rules,
        "label-width": "90px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "活动名称",
            prop: "name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.dialogHandle.formData.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dialogHandle.formData.name) = $event)),
                class: "form_input"
              }, null, 8, ["modelValue"]),
              _withDirectives(_createElementVNode("span", _hoisted_1, "必填，最多15个字符，新建后可编辑", 512), [
                [_vShow, !_ctx.isEdit]
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "活动标识",
            prop: "code"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.dialogHandle.formData.code,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dialogHandle.formData.code) = $event)),
                class: "form_input"
              }, null, 8, ["modelValue"]),
              _withDirectives(_createElementVNode("span", _hoisted_2, "必填，活动唯一标识", 512), [
                [_vShow, !_ctx.isEdit]
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "所属产品",
            prop: "client_type"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.dialogHandle.formData.client_type,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dialogHandle.formData.client_type) = $event)),
                class: "form_select",
                disabled: _ctx.isEdit
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clientList, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.text,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"]),
              _withDirectives(_createElementVNode("span", _hoisted_3, "必选，开发创建选项，新建后不可编辑", 512), [
                [_vShow, !_ctx.isEdit]
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "活动模板",
            prop: "template"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.dialogHandle.formData.template,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dialogHandle.formData.template) = $event)),
                class: "form_select",
                disabled: _ctx.isEdit
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.templateList, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.text,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"]),
              _withDirectives(_createElementVNode("span", _hoisted_4, "必选，开发创建选项，新建后不可编辑", 512), [
                [_vShow, !_ctx.isEdit]
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "开始时间",
            prop: "start_time"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.dialogHandle.formData.start_time,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dialogHandle.formData.start_time) = $event)),
                "value-format": "YYYY-MM-DD HH:mm:ss",
                type: "datetime",
                placeholder: "开始时间"
              }, null, 8, ["modelValue"]),
              _withDirectives(_createElementVNode("span", _hoisted_5, "必填，新建后可编辑", 512), [
                [_vShow, !_ctx.isEdit]
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "结束时间",
            prop: "start_time"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.dialogHandle.formData.end_time,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dialogHandle.formData.end_time) = $event)),
                class: "form_time_picker",
                "value-format": "YYYY-MM-DD HH:mm:ss",
                type: "datetime",
                placeholder: "结束时间"
              }, null, 8, ["modelValue"]),
              _withDirectives(_createElementVNode("span", _hoisted_6, "必填，新建后可编辑", 512), [
                [_vShow, !_ctx.isEdit]
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "状态",
            prop: "status"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_switch, {
                "model-value": _ctx.dialogHandle.formData.status === _ctx.StatusActivityMap.open,
                "inline-prompt": "",
                "active-text": "开",
                "inactive-text": "关",
                disabled: !_ctx.isEdit,
                onChange: _ctx.dialogHandle.handleSwitchChange
              }, null, 8, ["model-value", "disabled", "onChange"]),
              _withDirectives(_createElementVNode("span", _hoisted_7, "必填，默认关闭状态，新建后可编辑", 512), [
                [_vShow, !_ctx.isEdit]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["title", "before-close"]))
}